import {
  DetailsColumn,
  DetailsContainer,
  DetailsLabel,
  DetailsRow,
  DetailsText,
} from "../../../../constants/component.constants";
import ModalContainerModule from "../../../modules/modalContainer";
import { formatCurrency, formatDate } from "../../../../util/util";

const ViewCashToBank = (props) => {
  return (
    <ModalContainerModule
      size="sm"
      cancelText="Close"
      cancel={() => props.close()}
      openModal={props.open}
      modalTitle="Cash To Bank Details"
    >
      <DetailsContainer sx={{ marginTop: 0, paddingTop: 0 }} container>
        <DetailsColumn sx={{ width: { xs: "100%", lg: "50%" } }}>
          <DetailsRow sx={{ display: { xs: "none", lg: "flex" } }}>
            <DetailsLabel> Description: </DetailsLabel>
            <DetailsText>{props.transfer?.description ?? ""}</DetailsText>
          </DetailsRow>
          <DetailsRow>
            <DetailsLabel> Entry Date: </DetailsLabel>
            <DetailsText>{formatDate(props.transfer?.entryDate)}</DetailsText>
          </DetailsRow>
          <DetailsRow>
            <DetailsLabel> Posting Date: </DetailsLabel>
            <DetailsText>{formatDate(props.transfer?.postingDate)}</DetailsText>
          </DetailsRow>
        </DetailsColumn>
        <DetailsColumn sx={{ width: { xs: "100%", lg: "50%" } }}>
          <DetailsRow>
            <DetailsLabel> Applied to: </DetailsLabel>
            <DetailsText>{props.transfer?.appliedTo}</DetailsText>
          </DetailsRow>
          <DetailsRow>
            <DetailsLabel> Created By: </DetailsLabel>
            <DetailsText>{props.transfer?.createdByName}</DetailsText>
          </DetailsRow>
          <DetailsRow>
            <DetailsLabel> From: </DetailsLabel>
            <DetailsText>{props.transfer?.from}</DetailsText>
          </DetailsRow>
          <DetailsRow>
            <DetailsLabel>To: </DetailsLabel>
            <DetailsText>{props.transfer?.to}</DetailsText>
          </DetailsRow>
          <DetailsRow>
            <DetailsLabel> Amount: </DetailsLabel>
            <DetailsText>
              {formatCurrency(props.transfer?.amount)}
            </DetailsText>
          </DetailsRow>
        </DetailsColumn>
      </DetailsContainer>
    </ModalContainerModule>
  );
};

export default ViewCashToBank;
